import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuIvfTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);

  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].summary) {
      return 'N/A';
    }
    if (data[index].summary[key] === null || data[index].summary[key] === '') {
      return 'N/A';
    }

    if (key === '2pn' || key === '1pn' || key === '3pn' || key === 'degen') {
      const oocyteEmbryo = data[index].oocyteEmbryo;
      if (!oocyteEmbryo) {
        return 'N/A';
      }

      let count = 0;
      for (let i = 0; i < oocyteEmbryo.day0.data.length; i++) {
        if (
          key === '2pn' &&
          oocyteEmbryo.day0.data[i].type === 'IVF' &&
          oocyteEmbryo.day1.data[i].pn === '2'
        ) {
          count++;
        }

        if (
          key === '1pn' &&
          oocyteEmbryo.day0.data[i].type === 'IVF' &&
          oocyteEmbryo.day1.data[i].pn === '1'
        ) {
          count++;
        }

        if (
          key === '3pn' &&
          oocyteEmbryo.day0.data[i].type === 'IVF' &&
          (oocyteEmbryo.day1.data[i].pn === '3' ||
            oocyteEmbryo.day1.data[i].pn === '>3')
        ) {
          count++;
        }

        if (
          key === 'degen' &&
          oocyteEmbryo.day0.data[i].type === 'IVF' &&
          oocyteEmbryo.day1.data[i].pn === 'Degenerated'
        ) {
          count++;
        }
      }
      return count;
    }

    return data[index].summary[key] ?? 'N/A';
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={6}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            IVF DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '120px' }}>
              No. of OCC Directed For Conventional IVF
            </div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '60px' }}> No. of Fert. IVF (2PN)</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '60px' }}>No. of Fert. IVF (1PN)</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '90px' }}>No. of Fert. IVF 3PN/Multi-PN</div>
          </TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            <div style={{ width: '60px' }}>No. of Immature Oocytes</div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={6}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('ivfCoc', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('2pn', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('1pn', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('3pn', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('degen', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuIvfTable;
